(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bit-cart-recommendations"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bit-cart-recommendations')) {
    customElements.define(
      'bit-cart-recommendations',
      class BitCartRecommendations extends HTMLElement {
        connectedCallback() {
          if (this.connected) return;
          this.connected = true;
          this.itemsContainer = this.querySelector('[data-bit-cart-recommendations-items]');
          this.statusElement = this.querySelector('[data-bit-cart-recommendations-status]');
          this.totalElement = this.querySelector('[data-bit-cart-recommendations-total]');
          this.addSelectedButton = this.querySelector('[data-bit-cart-recommendations-add-selected]');
          this.addEventListener('change', (event) => this.handleChange(event));
          this.addEventListener('click', (event) => this.handleClick(event));
          this.observeCartSurface();
          this.load();
        }

        disconnectedCallback() {
          this.cartObserver?.disconnect();
          this.abortController?.abort();
          window.clearTimeout(this.reloadTimer);
        }

        observeCartSurface() {
          const target =
            this.dataset.placement === 'notification'
              ? document.getElementById('cart-notification-product')
              : document.getElementById('main-cart-items');
          if (!target) return;
          this.cartObserver = new MutationObserver(() => {
            window.clearTimeout(this.reloadTimer);
            this.reloadTimer = window.setTimeout(() => this.load(), 120);
          });
          this.cartObserver.observe(target, { childList: true, subtree: true });
        }

        async load(force = false) {
          this.abortController?.abort();
          this.abortController = new AbortController();
          const signal = this.abortController.signal;

          try {
            const cartResponse = await fetch(`${this.dataset.cartUrl}.js`, {
              headers: { Accept: 'application/json' },
              signal,
            });
            if (!cartResponse.ok) throw new Error();
            const cart = await cartResponse.json();
            const productIds = [...new Set(cart.items.map((item) => String(item.product_id)))];
            const signature = productIds.join(':');

            if (!productIds.length) {
              this.hidden = true;
              return;
            }

            if (!force && signature === this.cartSignature && this.itemsContainer.children.length) return;
            this.cartSignature = signature;
            this.hidden = true;
            this.itemsContainer.replaceChildren();
            this.setStatus(this.dataset.loadingText);

            const resultGroups = await Promise.all(
              productIds.map((productId) => this.fetchRecommendations(productId, signal))
            );
            if (signal.aborted) return;

            const existingProductIds = new Set(productIds);
            const renderedProductIds = new Set();
            const cards = [];

            for (const group of resultGroups) {
              for (const card of group) {
                const productId = card.dataset.productId;
                if (existingProductIds.has(productId) || renderedProductIds.has(productId)) continue;
                renderedProductIds.add(productId);
                cards.push(card);
                if (cards.length >= Number(this.dataset.limit)) break;
              }
              if (cards.length >= Number(this.dataset.limit)) break;
            }

            if (!cards.length) {
              this.setStatus('');
              this.hidden = true;
              return;
            }

            this.itemsContainer.append(...cards);
            this.hidden = false;
            this.setStatus('');
            this.updateSelection();
            this.track('bit_cross_sell_view', {
              placement: this.dataset.placement,
              recommended_product_ids: cards.map((card) => card.dataset.productId),
            });
          } catch (error) {
            if (error.name === 'AbortError') return;
            this.setStatus('');
            this.hidden = true;
          }
        }

        async fetchRecommendations(productId, signal) {
          const url = new URL(this.dataset.endpoint, window.location.origin);
          url.searchParams.set('section_id', this.dataset.sectionId);
          url.searchParams.set('product_id', productId);
          url.searchParams.set('limit', this.dataset.queryLimit);
          url.searchParams.set('intent', 'complementary');

          const response = await fetch(url, { signal });
          if (!response.ok) return [];
          const html = await response.text();
          const documentFragment = new DOMParser().parseFromString(html, 'text/html');
          return Array.from(
            documentFragment.querySelectorAll('[data-bit-cart-recommendation-card]')
          ).map((card) => card.cloneNode(true));
        }

        handleChange(event) {
          const card = event.target.closest('[data-bit-cart-recommendation-card]');
          if (!card) return;

          if (event.target.matches('[data-bit-cart-recommendation-check]')) {
            this.track('bit_cross_sell_select', {
              placement: this.dataset.placement,
              product_id: card.dataset.productId,
              selected: event.target.checked,
            });
          }

          this.updateSelection();
        }

        handleClick(event) {
          const addButton = event.target.closest('[data-bit-cart-recommendation-add]');
          if (addButton) {
            const card = addButton.closest('[data-bit-cart-recommendation-card]');
            if (card) this.addItems([this.getCardItem(card)], addButton);
            return;
          }

          const addSelectedButton = event.target.closest('[data-bit-cart-recommendations-add-selected]');
          if (!addSelectedButton) return;
          const selectedCards = Array.from(
            this.querySelectorAll('[data-bit-cart-recommendation-check]:checked')
          ).map((checkbox) => checkbox.closest('[data-bit-cart-recommendation-card]'));

          if (!selectedCards.length) {
            this.setStatus(this.dataset.emptySelectionText);
            return;
          }

          this.addItems(
            selectedCards.map((card) => this.getCardItem(card)),
            addSelectedButton
          );
        }

        getCardItem(card) {
          const variantField = card.querySelector('[data-bit-cart-recommendation-variant]');
          const selectedOption =
            variantField.tagName === 'SELECT' ? variantField.selectedOptions[0] : variantField;
          return {
            id: Number(variantField.value),
            quantity: 1,
            price: Number(selectedOption.dataset.price),
            productId: card.dataset.productId,
          };
        }

        updateSelection() {
          if (!this.addSelectedButton || !this.totalElement) return;
          const selectedCards = Array.from(
            this.querySelectorAll('[data-bit-cart-recommendation-check]:checked')
          ).map((checkbox) => checkbox.closest('[data-bit-cart-recommendation-card]'));
          const total = selectedCards.reduce((sum, card) => sum + this.getCardItem(card).price, 0);
          const formatter = new Intl.NumberFormat(this.dataset.locale || 'pt-BR', {
            style: 'currency',
            currency: this.dataset.currency || 'BRL',
          });
          this.totalElement.textContent = formatter.format(total / 100);
          this.addSelectedButton.disabled = selectedCards.length === 0;
        }

        async addItems(items, button) {
          if (!items.length || button.disabled) return;
          button.disabled = true;
          button.setAttribute('aria-busy', 'true');
          this.setStatus('');

          try {
            const response = await fetch(this.dataset.addUrl, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
              },
              body: JSON.stringify({
                items: items.map(({ id, quantity }) => ({ id, quantity })),
                sections: ['cart-icon-bubble', 'cart-notification-button'],
                sections_url: window.location.pathname,
              }),
            });
            const result = await response.json();
            if (!response.ok) throw new Error(result.description || result.message);

            this.updateRenderedSection('cart-icon-bubble', result.sections?.['cart-icon-bubble']);
            this.updateRenderedSection(
              'cart-notification-button',
              result.sections?.['cart-notification-button']
            );
            this.track('bit_cross_sell_add', {
              placement: this.dataset.placement,
              recommended_product_ids: items.map((item) => item.productId),
              value: items.reduce((sum, item) => sum + item.price, 0) / 100,
              currency: this.dataset.currency || 'BRL',
            });

            if (this.dataset.placement === 'page') {
              this.setStatus(this.dataset.addedSelectedText);
              window.setTimeout(() => window.location.reload(), 350);
              return;
            }

            this.setStatus(this.dataset.addedText);
            await this.load(true);
          } catch (error) {
            this.setStatus(error.message || this.dataset.errorText);
            button.disabled = false;
          } finally {
            button.removeAttribute('aria-busy');
          }
        }

        updateRenderedSection(id, html) {
          if (!html) return;
          const target = document.getElementById(id);
          if (!target) return;
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const section = parsed.querySelector('.shopify-section');
          target.innerHTML = section ? section.innerHTML : html;
        }

        setStatus(message) {
          if (this.statusElement) this.statusElement.textContent = message || '';
        }

        track(event, payload) {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ event, ...payload });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
